import { Injectable } from '@angular/core';
import { PortfolioCurrencyGQL } from '../data-services/graphql';

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    private currencySymbol: string = '€';
    private currencyCode: string = 'EUR';

    constructor(
        private portfolioCurrencyGQL: PortfolioCurrencyGQL
    ) {
        this.getPortfolioCurrencyData();
    }

    private getPortfolioCurrencyData(){
        this.portfolioCurrencyGQL.fetch().toPromise().then(r => {
            const currencyData = r.data.portfolios[0].currency;
            this.currencyCode = currencyData.code;
            
            if (currencyData.symbol) {
                this.currencySymbol = currencyData.symbol;
            } else {
                console.warn('No currency symbol provided by backend, using currency code as symbol');
                this.currencySymbol = this.currencyCode;
            }
        }).catch(error => {
            console.warn('Error fetching portfolio currency data:', error);
        });
    }

    public getCurrencySymbol(){
        return this.currencySymbol;
    }

    public getCurrencyCode(){
        return this.currencyCode;
    }
}